import * as moment from 'moment'
import React from 'react'

const Date = ({ date }) => {
  return <time>{moment(date).format('DD.MM.YY')}</time>
}

export default Date
